<template>
  <lateral-modal
    :title="$t(dietModalHeader)"
    :containerClass="isDragging && !transactionWithoutReceipt ? 'ModalBox--dim' : ''"
    :modalClass="isReceiptModalOpen ? 'ModalBox--receipt-open' : ''"
    :footerClass="'grid-diet grid-diet--footer pr-3'"
    @close="checkCloseModal"
  >
    <template slot="extraAction">
      <transactions-dropdown
        deleteText="transaction_delete_diet"
        :transactionId.sync="transactionId"
        @confirmDelete="deleteTransaction"
      ></transactions-dropdown>
    </template>
    <template slot="content">
      <modal-drop-zone
        v-if="isDragging && !transactionWithoutReceipt"
        :showDropZone.sync="isDragging"
        @dragleave="onDragleave"
        @drop="ondrop"
        :fileCount="receiptCount"
        :showSpinner="fileUploadByDrop"
      />
      <template v-if="!isInitializing && !isSubmitting">
        <form
          class="grid-diet"
          @submit.prevent="submitDietHandler"
          @dragenter.prevent="onDragenter"
          id="create-diet-form"
        >
          <div class="grid-diet--first-column">
            <transaction-review-status-log
              :transaction="transaction"
              v-if="transactionId"
            />
            <warning-container
              :transaction="transaction"
              @showIgnoreWarning="showIgnoreWarning"
              @showTransactionModal="showTransactionModal"
            />
            <div class="mb-3">
              <receipts-container
                ref="receiptsContainer"
                :transactionIsLocked="transactionIsLocked"
                :isProcessing="isProcessing"
                :transactionId="transactionId"
                :receipts="receipts"
                :transactionWithoutReceiptNotes="transactionWithoutReceiptNotes"
                :transactionWithoutReceipt="transactionWithoutReceipt"
                :required="fieldIsRequired('medias')"
                @showReceiptModal="emitShowReceiptModal"
                @uploadedReceipt="uploadedReceipt"
                @sendToReview="submitDietHandler"
                :expenseType="expenseType"
              ></receipts-container>
            </div>
            <div class="input--block input--block--margin">
              <label
                for="transaction-category-input"
                class="form--label"
                :class="fieldIsRequired('paymentMethod')"
              >
                {{
                    $t('expense_payment_method').toUpperCase()
                  }}
              </label>
              <div
                class="multiselect-filter"
                :class="{'multiselect--error' : $v.paymentMethod.$error}"
              >
                <multiselect
                  v-if="paymentMethods.length > 0"
                  :id="'expense-payment-method-selector'"
                  :options="paymentMethods"
                  :customLabel="(option) => paymentMethodsLabel(option)"
                  v-model="paymentMethod"
                  :disabled="transactionIsLocked || isProcessing"
                  :placeholder="$t('expense_payment_method')"
                  track-by="id"
                  :allowEmpty="false"
                  :showLabels="false"
                  @open="$v.paymentMethod.$touch()"
                >
                  <div
                    class="caret"
                    slot="caret"
                    slot-scope="{ toggle }"
                    @mousedown.prevent.stop="toggle"
                  >
                    <i
                      class="Ctrl Ctrl--16"
                      aria-hidden="true"
                    >
                      <svg
                        focusable="false"
                        aria-hidden="true"
                        e
                        aria-label="Edit"
                      >
                        <use xlink:href="#dropdown-icon"></use>
                      </svg>
                    </i>
                  </div>
                  <template
                    slot="singleLabel"
                    slot-scope="props"
                  >
                    <template v-if="props.option && props.option.officePaymentMethod">
                      <span>{{props.option.officePaymentMethod.name}}</span> <span class="multiselect--extra-info-gray"> - {{props.option.officePaymentMethod.repayable ? $t('expenses_expense_is_reimbursable') : $t('expenses_expense_is_not_reimbursable')}}</span>
                    </template>
                  </template>
                </multiselect>
              </div>
            </div>

            <!-- budget here -->
            <div class="input--block input--block--margin">
              <label
                for="mileage-amount"
                class="form--label"
                :class="fieldIsRequired('budget')"
              >{{$t('BUDGETS').toUpperCase()}}</label>
              <div class="multiselect-filter">
                <multi-select-input
                  :options="generateBudgetList()"
                  :placeholder="$t('BUDGETS')"
                  :value="budget"
                  :disabled="transactionIsLocked || isProcessing"
                  :customLabelField="'name'"
                  id="transaction-budget-selector"
                  emitFullValue
                  searchable
                  @inputSelected="setBudget($event, INCLUDE_IN_TRANSACTION_TYPES.DIET)"
                ></multi-select-input>
              </div>
            </div>

            <div class="diet-location-container">
              <div
                class="diet-location-container--row"
                v-for="(dietStep, index) in dietSteps"
                :key="index"
              >
                <div
                  class="diet-step--block mr-1"
                  :class="{ 'block--destination' : isLastDietStep(dietStep) && !transactionIsLocked && !isProcessing }"
                >
                  <div class="d-flex flex-column ">
                    <label
                      for="mileage-origin"
                      class="form--label"
                      :class="fieldIsRequired('dietSteps')"
                    >{{ generateAutocompleteLabel(dietStep)}}</label>

                    <div
                      class="Form-field Form-field--origin "
                      :class="{'Form--field-error' : $v.dietSteps.$each[index].placeInfo.name.$error}"
                    >
                      <google-places-autocomplete
                        :id="`diet-origin-${index}`"
                        :value="dietStep.placeInfo.name"
                        :classname="'Input-text'"
                        :disabled="transactionIsLocked || isProcessing"
                        @placechanged="setLocation(index, $event)"
                        @change="setLocation(index,$event)"
                        @blur="$v.dietSteps.$each[index].placeInfo.name.$touch()"
                      >
                      </google-places-autocomplete>

                    </div>
                    <span
                      v-if="isLastDietStep(dietStep) && !transactionIsLocked && !isProcessing"
                      @click="addDietStep(dietStep.stepOrder)"
                      class="add-destiny non-res clickable"
                    >
                      {{$t('expense_diet_add_destination')}}
                    </span>
                  </div>
                </div>
                <div :class="{'diet-step--block' : dietStep.stepOrder ===1 || (dietStep.stepOrder === 2 && dietSteps.length <= 2), 'diet-step--block--date' : dietStep.stepOrder >=2 && dietSteps.length > 2 }">
                  <div
                    class="d-flex flex-column flex-start"
                    :class="{'last--step' :  (isLastDietStep(dietStep) && dietSteps.length > 2), 'Form-field--res' : dietStep.stepOrder >=2 && dietSteps.length > 2}"
                  >
                    <label class="form--label u-required"> {{$t('expense_edit_expense_date').toUpperCase()}}</label>
                    <date-picker-input
                      :mode="isPlexus ? 'date' : 'dateTime'"
                      :placeholder="'expense_edit_expense_date'"
                      :errorClass="$v.dietSteps.$each[index].date.$error"
                      :value="dietStep.date"
                      containerClass
                      :minDate="getMinDateForDietStep(dietStep)"
                      :maxDate="getMaxDateForDietStep(dietStep)"
                      :disabled="transactionIsLocked || isProcessing"
                      @hide="$v.dietSteps.$each[index].date.$touch()"
                      @inputDate="setDietStepDate(dietStep,$event)"
                    ></date-picker-input>
                  </div>
                  <span
                    v-if="(dietStep.stepOrder >= 2 && dietSteps.length > 2) && !transactionIsLocked && !isProcessing"
                    class="clickable mt-2"
                    @click="removeStep(dietStep.stepOrder)"
                  >
                    <inline-svg
                      alt="icon-add"
                      :src="require('@/assets/img/icons/icon-trash-red.svg')"
                    ></inline-svg>
                  </span>

                </div>
                <span
                  v-if="isLastDietStep(dietStep) && !transactionIsLocked && !isProcessing"
                  @click="addDietStep(dietStep.stepOrder)"
                  class="add-destiny res clickable"
                >
                  {{$t('expense_diet_add_destination')}}
                </span>

              </div>
            </div>

            <div
              class="map--smaller"
              v-if="hasDefinedAtLeastToWaypoints"
            >

              <google-maps
                :id="`google-maps-small-${mapsId}`"
                :waypoints="routeWaypoints"
                :mapClass="'map-content--small'"
                v-if="hasDefinedAtLeastToWaypoints"
              />
            </div>
            <!-- Diet Categories -->
            <div class="mt-4 mb-2">
              <label
                for=""
                class="form--label mb-3"
                :class="fieldIsRequired('dietCategoryConfigs')"
              >{{$t('expenses_create_diet_categories_to_apply').toUpperCase()}}</label>

              <template v-if="dietCategories.length > 5">
                <div class="multiselect-custom-field mb-2">
                  <multiselect
                    :options="dietCategoryList"
                    multiple
                    :customLabel="(option) => option.dietCategory.name"
                    :searchable="true"
                    :value="selectedDietCategories"
                    clearOnSelect
                    :showLabels="false"
                    @select="addSelectedDietCategory"
                    @remove="removeDietCategory($event)"
                    :placeholder="$t('expense_create_diet_category_select_diet_category_placeholder')"
                  >
                    <div
                      class="caret"
                      slot="caret"
                      slot-scope="{ toggle }"
                      @mousedown.prevent.stop="toggle"
                    >
                      <i
                        class="Ctrl Ctrl--16"
                        aria-hidden="true"
                      >
                        <svg
                          focusable="false"
                          aria-hidden="true"
                          e
                          aria-label="Edit"
                        >
                          <use xlink:href="#dropdown-icon"></use>
                        </svg>
                      </i>
                    </div>

                    <template slot="noResult">
                      <span>{{ $t('user_finder_selector_no_results') }}</span>
                    </template>
                    <template slot="noOptions">
                      <span> {{ $t('user_finder_selector_no_results') }}</span>
                    </template>

                    <template v-slot:tag="{option}">

                      <span class="multiselect__tag multiselect__tag--no-remove">{{option.dietCategory.name}}</span>
                    </template>
                  </multiselect>
                </div>

              </template>
              <template v-if="dietCategories.length > 0">
                <div
                  class="d-flex justify-content-between align-items-center row"
                  v-for="dietCategory in selectedDietCategories"
                  :key="dietCategory.dietCategory.id"
                >
                  <div class="d-flex w-100 col-6">
                    <span class="Fuell-Text ">{{dietCategory.dietCategory.name}} - {{dietCategory.dietCategory.rate | currency('€', 2, { symbolOnLeft: false, thousandsSeparator: '.',  decimalSeparator: ',' })}}</span>
                  </div>

                  <div class="d-flex justify-content-between align-items-center col-6">
                    <div
                      class="Form-field Form-field--shorter d-flex align-items-center justify-content-center"
                      :class="{'Form--field-error' : categoryError}"
                    >

                      <currency-input
                        class="Fuell-Text-Input Fuell-Text-Input--short text-center"
                        :currency="null"
                        :precision="0"
                        :disabled="transactionIsLocked || isProcessing"
                        @input="handleCategoryConfig(dietCategory, $event)"
                        :distractionFree="false"
                        :value="dietCategory.count"
                        :allow-negative="false"
                        :value-range="{min: 0, max:999}"
                      ></currency-input>
                    </div>

                    <div class="Form-field Form-field--white Form-field--short position-relative">
                      <currency-input
                        class="Fuell-Text-Input Fuell-Text-Input--white Fuell-Text-Input--short Fuell-Text-Input--border-bottom currency-input mt-2"
                        disabled
                        :currency="null"
                        :allow-negative="false"
                        :value="dietCategory.value"
                      ></currency-input>
                      <span class="currency-symbol position-absolute">€</span>
                    </div>
                    <div>
                      <button
                        class="Fuell-IconButton Fuell-IconButton--no-margin Fuell-IconButton--close"
                        @click="removeDietCategory(dietCategory)"
                      >
                        <img
                          class="Fuell-IconButton--close-img"
                          :src="require('@/assets/img/icons/close.svg')"
                          alt="Close"
                        />

                      </button>

                    </div>

                  </div>

                </div>
              </template>

              <template v-if="dietCategories.length === 0">
                <div class="col-12 my-5 text-center">
                  <i18n
                    path="expenses_create_diet_no_categories_found_admin"
                    tag="span"
                    class="Fuell-Text"
                    v-if="isAdmin || isBookKeeper"
                  >
                    <template v-slot:link>
                      <router-link
                        class="text-primary"
                        :to="{name:'expense_fields'}"
                      >{{$t('ACTION_CLICK_HERE')}}</router-link>
                    </template>

                  </i18n>
                  <span
                    v-else
                    class="Fuell-Text"
                    v-t.preserve="{path:'expenses_create_diet_no_categories_found'}"
                  ></span>
                </div>
              </template>
            </div>
            <div
              class="d-flex mt-2 mb-3"
              v-if="totalDiet > 0"
            >
              <i18n
                tag="span"
                class="Fuell-Text"
                path="expense_diet_amount_summary"
              >
                <template v-slot:totalAmount>
                  <span> {{totalDiet | currency('€', 2, {symbolOnLeft:false, thousandsSeparator:'.', decimalSeparator:','})}}</span>
                </template>
              </i18n>

            </div>
            <!---->

            <div class="input--block input--block--margin mt-3">
              <label
                for="expense-notes"
                class="form--label"
                :class="fieldIsRequired('notes')"
              >
                {{ $t('expense_notes').toUpperCase() }}
              </label>
              <div class="Form-field">
                <input
                  type="text"
                  class="Input-text"
                  name="expense-notes"
                  :disabled="transactionIsLocked || isProcessing"
                  :placeholder="$t('expense_notes')"
                  v-model.trim="diet.notes"
                  id=""
                >
              </div>
            </div>
            <template v-if="isFetchingBudgetTagTypes">
              <div class="d-flex justify-content-center w-100">
                <spinner />
              </div>
            </template>
            <template v-if="!isFetchingBudgetTagTypes && selectedBudgetMandatoryTagTypes.length > 0">
              <div
                class="input--block input--block--margin"
                v-for="item in selectedBudgetMandatoryTagTypes"
                :key="item.id"
              >
                <label
                  for="transaction-tag"
                  class="form--label"
                  :class="{ 'u-required': item.mandatory }"
                >{{ item.tagType.name.toUpperCase() }}</label>
                <div class="multiselect-custom-field">
                  <option-settings-input
                    id="transaction-tag"
                    :disabled="transactionIsLocked"
                    :allowMultiple="item.tagType.multipleOptionsEnabled"
                    :allowTaggable="item.tagType.customOptionEnabled"
                    :alternateOptions="item.tagType.tags"
                    :overrideValue="handleCustomFieldValues(item.tagType)"
                    :noOptionsLabel="
                      'company_create_transaction_field_options_no_options'
                    "
                    useOptionSlot
                    :noResultLabel="'multiselect_no_result_slot_default'"
                    :placeholder="item.tagType.name"
                    :tag-placeholder="
                      $t(
                        handleCreateTagPlaceholder(
                          item.tagType.customOptionEnabled
                        )
                      )
                    "
                    emitTagTypeOnClose
                    :searchable="true"
                    :customField="item.tagType"
                    :class="{ 'multiselect--error': item.invalid }"
                    closeOnSelect
                    internalSearch
                    @select="addTagToTransactionTag(item, $event)"
                    @remove="removeTagFromTransactionTag"
                    @tag="handleCreateOption(item, $event)"
                  ></option-settings-input>
                </div>
              </div>
            </template>
            <template v-if="!isFetchingBudgetTagTypes && selectedBudgetNoMandatoryTagTypes.length > 0">
              <div
                class="input--block input--block--margin"
                v-for="item in selectedBudgetNoMandatoryTagTypes"
                :key="item.id"
              >
                <label
                  for="transaction-tag"
                  class="form--label"
                  :class="{ 'u-required': item.mandatory }"
                >{{ item.tagType.name.toUpperCase() }}</label>
                <div class="multiselect-custom-field">
                  <option-settings-input
                    id="transaction-tag"
                    :disabled="transactionIsLocked"
                    :allowMultiple="item.tagType.multipleOptionsEnabled"
                    :allowTaggable="item.tagType.customOptionEnabled"
                    :alternateOptions="item.tagType.tags"
                    :overrideValue="handleCustomFieldValues(item.tagType)"
                    :noOptionsLabel="
                      'company_create_transaction_field_options_no_options'
                    "
                    :noResultLabel="'multiselect_no_result_slot_default'"
                    :placeholder="item.tagType.name"
                    :tag-placeholder="
                      $t(
                        handleCreateTagPlaceholder(
                          item.tagType.customOptionEnabled
                        )
                      )
                    "
                    useOptionSlot
                    emitTagTypeOnClose
                    :searchable="true"
                    :customField="item.tagType"
                    :class="{ 'multiselect--error': item.invalid }"
                    closeOnSelect
                    internalSearch
                    @select="addTagToTransactionTag(item, $event)"
                    @remove="removeTagFromTransactionTag"
                    @tag="handleCreateOption(item, $event)"
                  ></option-settings-input>
                </div>
              </div>
            </template>

          </div>
          <div
            class="grid-diet--map-column"
            :class="mapColumnClass"
          >
            <google-maps
              :id="`google-maps-${mapsId}`"
              :waypoints="routeWaypoints"
              :mapClass="'map-content'"
              v-if="hasDefinedAtLeastToWaypoints"
            ></google-maps>
            <template v-else>
              <div class="d-flex justify-content-center align-items-center map-content">
                <span
                  class="Fuell-Text"
                  v-t="{path:'expense_create_diet_define_waypoints'}"
                ></span>
              </div>
            </template>

          </div>

        </form>

        <div class="buffer"></div>

      </template>
      <template v-else>
        <div class="w-100 h-100 d-flex justify-content-center align-items-center">
          <spinner></spinner>
        </div>
      </template>
    </template>
    <template
      slot="footer"
      v-if="!isInitializing"
    >

      <div
        class="grid-diet--first-column py-3"
        v-if="showSaveAsDraftButton || showSendToReviewButton || showSaveButton"
      >
        <button
          class="Fuell-Button orange mb-2"
          v-if="showSaveAsDraftButton"
          @click="draftHandler"
          :disabled="transactionIsLocked || isSubmitting || !isDirty ||isProcessing"
          :class="{'disabled' : transactionIsLocked || isSubmitting || !isDirty  ||isProcessing}"
        >
          <span class="Fuell-Button--label w-100 text-center">
            {{$t('expenses_save_as_draft')}}
          </span>

        </button>
        <button
          class="Fuell-Button blue mb-2"
          v-if="showSendToReviewButton"
          @click="submitDietHandler"
          :disabled="transactionIsLocked || isSubmitting || !canBeSubmitted  ||isProcessing"
          :class="{'disabled' : transactionIsLocked || isSubmitting || !canBeSubmitted  ||isProcessing}"
        >
          <span class="Fuell-Button--label w-100 text-center">
            {{$t('expenses_send_to_review')}}
          </span>
        </button>
        <button
          class="Fuell-Button blue mb-2"
          v-if="showSaveButton"
          @click="submitDietHandler"
          :disabled="transactionIsLocked || isSubmitting || !isDirty  ||isProcessing"
          :class="{'disabled' : transactionIsLocked || isSubmitting || !isDirty  ||isProcessing}"
        >
          <span class="Fuell-Button--label w-100 text-center">
            {{$t('transactions_edit_transaction_save')}}
          </span>
        </button>
      </div>
      <template v-if="!transactionIsLocked && reviewStatus !== 'DRAFT' && transactionId && !isInExpensesSection && !isDirty &&!isProcessing">
        <funnel-actions
          class="grid-diet--first-column py-3"
          @reviewStatusChanged="emitReviewStatusChanged"
          :reviewStatus.sync="reviewStatus"
          :budgetOwner="isBudgetOwner"
          :expenseOwner="transactionOwner"
          :transactionId.sync="transactionId"
        />
      </template>

    </template>
    <template slot="modals">
      <transaction-not-receipt-modal
        v-if="showNotReceiptModalFlag"
        :open.sync="showNotReceiptModalFlag"
        @emitNotReceiptReason="handleNotReceipt"
      ></transaction-not-receipt-modal>
      <confirm-modal
        v-if="showSendToReviewWithoutReceipt"
        :open.sync="showSendToReviewWithoutReceipt"
        title="expenses_send_to_review"
        message="expenses_send_to_review_description"
        modalClass="ModalBox--400"
        acceptText="expenses_upload_receipt"
        dismissText="transaction_dont_have_receipt"
        acceptBtnClass="blue"
        @accept="showReceiptsContainer"
        @dismiss="showNotReceiptModal"
      ></confirm-modal>
      <confirm-modal
        v-if="showCloseWarning"
        :open.sync="showCloseWarning"
        title="transaction_close_without_save"
        message="transaction_close_without_save_description"
        modalClass="ModalBox--400"
        acceptText="transaction_close_delete"
        dismissText="transaction_close_delete_draft"
        acceptBtnClass="Button--danger"
        @accept="closeModal"
        @dismiss="draftHandler"
      ></confirm-modal>
      <confirm-modal
        v-if="showIgnoreWarningModal"
        :open.sync="showIgnoreWarningModal"
        modalClass="ModalBox--400"
        :title="'transaction_warning_ignore_modal'"
        :message="'transaction_warning_ignore_message'"
        :acceptText="'transaction_warning_ignore'"
        :dismissText="'ACTION_CANCEL'"
        acceptBtnClass="blue"
        dismissBtnClass="red"
        @accept="ignoreWarning"
        @dismiss="dismissWarning"
      ></confirm-modal>
      <confirm-modal
        v-if="showUploadInProgress"
        :open.sync="showUploadInProgress"
        :modalClass="'ModalBox--400'"
        :title="''"
        :message="''"
        :acceptText="'transaction_upload_in_progress_understood'"
        acceptBtnClass="blue"
        closeButton
        noPadding
        noMargin
        hideDismissButton
        @accept="uploadingAccept"
      >
        <template v-slot:content>
          <div class="transaction-upload-in-progress">
            <img
              :src="require('@/assets/img/upload-in-progress.svg')"
              alt=""
            />
            <p class="transaction-upload-in-progress--title">{{ $t('transaction_upload_in_progress_title') }}</p>
            <p class="transaction-upload-in-progress--description">{{ $t('transaction_upload_in_progress_description') }}</p>
          </div>
        </template>
      </confirm-modal>
      <choose-media-type-modal
        v-if="showMediaTypeModalFlag"
        :open.sync="showMediaTypeModalFlag"
        @typeSelected="typeIsSelected"
      ></choose-media-type-modal>
    </template>
  </lateral-modal>
</template>

<script>
import { REVIEW_STATUS } from '@/constants/reviewStatus'
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import _transactionReceiptHandler from '../../_mixins/_transactionReceiptDragAndDropHandler'
import _transactionAndExpenseCommon from '../../_mixins/_transactionAndExpenseCommon'
import _expenseBudgetSelectionHandlerMixin from '../../_mixins/_expenseBudgetSelectionHandlerMixin'
import _revissionFunnelActions from '../../_mixins/funnel/_revissionFunnelActionsMixin'
import _transactionStatusHandlerMixin from '../../_mixins/_transactionStatusHandlerMixin'
import _transactionsCustomFieldsHandler from '../../_mixins/_transactionsCustomFieldsHandler'
import _transactionsValidationHandlerMixin from '../../_mixins/_transactionsValidationHandlerMixin'
import _transactionsTicketHandlerMixin from '../../_mixins/_transactionsTicketHandlerMixin'

import DatePickerInput from '@/components/Commons/Forms/DatePickerInput'
import MultiSelectInput from '@/components/Commons/Forms/MultiSelectInput'
import FunnelActions from '../funnel/FunnelActions.vue'
import Multiselect from 'vue-multiselect'
import OptionSettingsInput from '@/modules/company/_components/_shared/OptionSettingsInput'
import TransactionReviewStatusLog from '../funnel/statusLog/TransactionReviewStatusLog.vue'
import WarningContainer from '../_shared/WarningContainer.vue'
/* import InputCheckbox from '@/components/Commons/Forms/InputCheckbox' */
import { CurrencyInput } from 'vue-currency-input'

import ModalDropZone from '@/components/Commons/ModalDropZone'
import Spinner from '@/components/Commons/Spinner'

import GooglePlacesAutocomplete from '@/components/Google/GooglePlacesAutocomplete'
import GoogleMaps from '@/components/Google/GoogleMaps'

import InlineSvg from 'vue-inline-svg'
import { cloneDeep } from 'lodash-es'
import { INCLUDE_IN_TRANSACTION_TYPES } from '../../_constants/constants'
import ReceiptsContainer from '@/components/Commons/ReceiptsContainer.vue'
import LateralModal from '@/components/Commons/Modals/LateralModal'
const TransactionsDropdown = () => import('../_shared/TransactionsDropdown')
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')
const ChooseMediaTypeModal = () => import('@/modules/transactions/_components/media/ChooseMediaTypeModal.vue')
const TransactionNotReceiptModal = () => import('../_shared/TransactionNotReceiptModal')

export default {
  name: 'CreateDietModal',
  components: {
    WarningContainer, ModalDropZone, Spinner, InlineSvg, ReceiptsContainer, Multiselect, GooglePlacesAutocomplete, CurrencyInput, DatePickerInput, GoogleMaps, MultiSelectInput, FunnelActions, OptionSettingsInput, TransactionReviewStatusLog, ConfirmModal, TransactionsDropdown, LateralModal, ChooseMediaTypeModal, TransactionNotReceiptModal
  },
  mixins: [
    _modalHandlerMixin,
    _transactionReceiptHandler,
    _transactionAndExpenseCommon,
    _expenseBudgetSelectionHandlerMixin,
    _revissionFunnelActions,
    _transactionStatusHandlerMixin,
    _transactionsCustomFieldsHandler,
    _transactionsValidationHandlerMixin,
    _transactionsTicketHandlerMixin
  ],
  props: {
    transactionId: {
      type: [Number, String]
    }
  },
  data () {
    return {
      showSendToReviewWithoutReceipt: false,
      showNotReceiptModalFlag: false,
      withoutTicket: {},
      expenseType: 'DIET',
      diet: {
        type: { id: 2 },
        amount: null,
        notes: '',
        date: null,
        diet: {
        }
      },
      dietSteps: [
        {
          date: null,
          placeInfo: {
            name: '',
            lat: '',
            lng: ''
          },
          stepOrder: 1
        },
        {
          date: null,
          placeInfo: {
            name: '',
            lat: '',
            lng: ''
          },
          stepOrder: 2
        }
      ],
      budget: null,
      paymentMethod: '',
      /* - Diet Categories -  */
      dietCategoryList: [],
      receiptLocalId: 1,
      selectedDietCategories: [],
      /* Map Waypoints  */
      routeWaypoints: [],
      mapsId: 1,
      isInitializing: false,
      isSubmitting: false,
      transactionTags: [],
      /// Experimento
      originalDietCategoryListData: [],
      originalDietStepsData: [],
      originalBudgetId: null,
      originalNotes: '',
      originalPaymentMethod: '',
      originalTransactionTags: [],
      showIgnoreWarningModal: false,
      categoryError: false
    }
  },
  computed: {
    INCLUDE_IN_TRANSACTION_TYPES () {
      return INCLUDE_IN_TRANSACTION_TYPES
    },
    mapColumnClass () {
      if (this.transactionId) {
        if (this.transaction?.warnings?.length > 0) {
          return 'grid-diet--map-column--with-warnings'
        } else {
          return 'grid-diet--map-column--with-info'
        }
      }
      return ''
    },
    canBeSubmitted () {
      return !this.$v.$invalid && this.budgetTagTypes.filter(item => item.mandatory && !item.filled).length === 0
    },
    dietModalHeader () {
      return this.transactionId ? 'expenses_edit_diet_header' : 'expenses_create_diet_header'
    },
    dietCategories () {
      return this.$store.getters['CompanyStore/ExpensesSettingsStore/dietCategories'] || []
    },
    hasDefinedAtLeastToWaypoints () {
      const hasAtLeastTwoSteps = this.dietSteps.length >= 2
      const hasAtLeatsTwoLocations = this.dietSteps.filter(el => el.placeInfo.lat).length > 1
      return hasAtLeastTwoSteps && hasAtLeatsTwoLocations
    },
    hasDefinedOriginAndDestination () {
      const originPoint = this.routeWaypoints.find(el => el.position === 'ORIGIN')
      const destinationPoint = this.routeWaypoints.find(el => el.position === 'DESTINATION')

      const hasDefinedOrigin = !!(originPoint && originPoint.lat && originPoint.lng)
      const hasDefinedDestination = !!(destinationPoint && destinationPoint.lat && destinationPoint.lng)

      return hasDefinedOrigin && hasDefinedDestination
    },

    expenseTypes () {
      return this.$store.getters['ConfigStore/privateConfig'].expense_types || []
    },
    totalDiet () {
      return this.selectedDietCategories.filter(item => item.count > 0).reduce((sum, { value }) => sum + value, 0)
    },
    someDietStepHasChanges () {
      return this.dietSteps.some(el => {
        return el.date !== null || el.placeInfo.name !== ''
      })
    },
    isDirty () {
      if (JSON.stringify(this.originalDietCategoryListData) !== JSON.stringify(this.dietCategoryList)) return true

      if (JSON.stringify(this.originalDietStepsData) !== JSON.stringify(this.dietSteps)) return true

      if (JSON.stringify(this.originalPaymentMethod) !== JSON.stringify(this.paymentMethod)) return true
      if (JSON.stringify(this.originalTransactionTags) !== JSON.stringify(this.transactionTags)) return true

      if (this.diet.notes !== this.originalNotes) return true

      if (this.budget !== this.originalBudgetId) return true

      if (this.expensesReceipts.length > 0) return true
      return false
    }

  },
  methods: {
    addSelectedDietCategory (option) {
      this.selectedDietCategories.push(option)
    },
    removeDietCategory (dietCategory) {
      this.selectedDietCategories = [...this.selectedDietCategories.filter(el => el.dietCategory.id !== dietCategory.dietCategory.id)]
      this.$forceUpdate()
    },
    showReceiptsContainer () {
      this.$refs.receiptsContainer.addReceipt(true)
    },
    showNotReceiptModal () {
      this.showNotReceiptModalFlag = !this.showNotReceiptModalFlag
    },
    handleNotReceipt (reason) {
      this.withoutTicket.withoutTicket = true
      this.withoutTicket.withoutTicketNotes = reason
      this.submitDietHandler()
    },
    setField (fieldName, value) {
      this[fieldName] = value
    },
    setLocation (dietStepIndex, event) {
      this.dietSteps[dietStepIndex].placeInfo.name = event.formatted_address ? event.formatted_address : event
      this.dietSteps[dietStepIndex].placeInfo.lat = event.latitude ? event.latitude : null
      this.dietSteps[dietStepIndex].placeInfo.lng = event.longitude ? event.longitude : null
      if (this.hasDefinedAtLeastToWaypoints) {
        this.routeWaypoints = this.generateMapWaypoints()
        this.mapsId++
      }
    },
    addDietStep (index) {
      const newLocation = {
        date: null,
        placeInfo: {
          name: '',
          lat: '',
          lng: ''
        },
        stepOrder: index + 1
      }
      this.dietSteps.push(newLocation)
    },
    removeStep (stepOrder) {
      this.dietSteps = [...this.dietSteps.filter(el => el.stepOrder !== stepOrder)]
      this.dietSteps.forEach((el, index) => {
        el.stepOrder = index + 1
      })
      if (this.hasDefinedAtLeastToWaypoints) {
        this.routeWaypoints = this.generateMapWaypoints()
        this.mapsId++
      }
    },
    isLastDietStep (dietStep) {
      const latestLocation = this.dietSteps[this.dietSteps.length - 1]
      return dietStep.stepOrder === latestLocation.stepOrder
    },
    setDietStepDate (dietStep, event) {
      if (this.isPlexus) event = this.$moment.utc(event).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format('YYYY-MM-DDTHH:mm:SS+00:00')
      dietStep.date = event
      this.getMinDateForDietStep(dietStep)
      this.getMaxDateForDietStep(dietStep)
    },
    isInCategoryList (dietCategory) {
      const { id } = dietCategory
      if (!id) return false
      return this.dietCategoryList.findIndex(el => el.id === dietCategory.id) > -1
    },

    handleCategoryConfig (dietCategory, event) {
      dietCategory.count = ''
      dietCategory.count = event || 0
      dietCategory.value = dietCategory.count * dietCategory.rate
      this.hasAnyCategoryFilled()
    },
    getMinDateForDietStep (dietStep) {
      if (!dietStep) return null
      const previousStepIndex = this.dietSteps.findIndex(el => el.stepOrder === dietStep.stepOrder) - 1
      if (previousStepIndex > -1) {
        // hay paso anterior, luego la fecha Minima, tiene que ser el dietStepAnterior
        return this.dietSteps[previousStepIndex] && this.dietSteps[previousStepIndex].date ? new Date(this.dietSteps[previousStepIndex].date) : null
      }
      return null
    },
    hasAnyCategoryFilled () {
      let hasAnyCategoryFilled = this.dietCategoryList.some(el => el.count !== 0)
      this.categoryError = !hasAnyCategoryFilled
    },

    getMaxDateForDietStep (dietStep) {
      if (!dietStep) return null
      const nextStepIndex = this.dietSteps.findIndex(el => el.stepOrder === dietStep.stepOrder) + 1
      if ((nextStepIndex > -1) && (nextStepIndex <= this.dietSteps.length)) {
        // hay paso anterior, luego la fecha Minima, tiene que ser el dietStepAnterior
        return this.dietSteps[nextStepIndex] && this.dietSteps[nextStepIndex].date ? new Date(this.dietSteps[nextStepIndex].date) : null
      }
      return null
    },
    generateAutocompleteLabel (dietStep) {
      if (dietStep.stepOrder <= 1) {
        return this.$t('expenses_create_diet_label_origin').toUpperCase()
      }
      if (this.isLastDietStep(dietStep)) {
        return this.$t('expenses_create_diet_label_destination').toUpperCase()
      }
      return this.$t('expenses_create_diet_label_to').toUpperCase()
    },
    async fetchDietCategories () {
      await this.$store.dispatch('CompanyStore/ExpensesSettingsStore/fetchDietCategories', { pagination: false })
    },
    _initializeDietCategoryList () {
      let formattedCategoriesList = []
      formattedCategoriesList = this.dietCategories.map(el => {
        return {
          count: 0,
          rate: el.rate,
          value: 0,
          dietCategory: { ...el },
          status: false
        }
      })
      this.dietCategoryList = formattedCategoriesList
      this.originalDietCategoryListData = cloneDeep(this.dietCategoryList)
      this._initializeSelectedDietCategories()
    },
    _initializeSelectedDietCategories () {
      if (this.dietCategoryList.length < 5) {
        this.selectedDietCategories = [...this.dietCategoryList]
      } else {
        this.selectedDietCategories = []
      }
    },
    generateMapWaypoints () {
      if (!this.hasDefinedAtLeastToWaypoints) return []

      const steps = this.dietSteps.map(el => {
        if (el.placeInfo.lat && el.placeInfo.lng) {
          const waypoint = {}
          waypoint.lat = el.placeInfo.lat
          waypoint.lng = el.placeInfo.lng
          waypoint.stepOrder = el.stepOrder

          return waypoint
        }
      })
      const validSteps = steps.filter(el => el)
      return validSteps.sort((a, b) => a.stepOrder - b.stepOrder)
    },
    generateDietModel () {
      const expense = {}
      const { id: dietExpenseTypeId } = this.expenseTypes.find(el => el.code === 'DIET')
      expense.type = { id: dietExpenseTypeId }
      const dietCategoryConfigs = [...this.selectedDietCategories.filter(el => el.count > 0)].map(el => {
        let config = { ...el }
        delete config.status
        return config
      })
      const dietAmount = this.selectedDietCategories.filter(el => el.count > 0).reduce((sum, { value }) => sum + value, 0)
      expense.amount = dietAmount * -1
      expense.date = this.dietSteps[0].date
      expense.diet = {}
      expense.diet.dietSteps = [...this.dietSteps.map(el => {
        const step = {
          ...el
        }

        return step
      })]
      expense.diet.dietCategoryConfigs = [...dietCategoryConfigs]
      expense.notes = this.diet.notes

      if (this.budget && !this.transactionId) {
        expense.budget = { id: this.budget.id }
      }
      if (this.paymentMethod?.id) {
        expense.paymentMethod = { id: this.paymentMethod.id }
      }
      return expense
    },
    async draftHandler () {
      if (this.isSubmitting) return
      if (this.transactionId) {
        await this.editDiet('DRAFT')
      } else {
        await this.createDiet('DRAFT')
      }
    },

    async submitDietHandler () {
      if (this.fieldIsRequired('medias') && !this.transaction.withoutTicket && ((!this.transaction.receipt?.receiptMedia || this.transaction.receipt?.receiptMedia?.length === 0) && this.expensesReceipts.length === 0) && !this.withoutTicket.withoutTicket) {
        this.showSendToReviewWithoutReceipt = true
      } else {
        if (this.transactionId) {
          if (this.reviewStatus === REVIEW_STATUS.DRAFT) {
            await this.editDiet(REVIEW_STATUS.AWAITING_REVIEW)
            return
          } else {
            await this.editDiet()
            return
          }
        }
        await this.createDiet(REVIEW_STATUS.AWAITING_REVIEW)
      }
    },
    async createDiet (reviewStatus) {
      /* if (this.$v.invalid || this.invalidCategorySettings) return */
      if (this.isSubmitting) return
      this.isSubmitting = true
      const expense = { ...this.generateDietModel() }
      expense.reviewStatusCode = reviewStatus
      if (this.transactionTags.length > 0) {
        const formatedTransactionTags = this.transactionTags.map(el => {
          if (typeof el.tag.id === 'string') {
            const formated = {
              tag: {
                name: el.tag.name,
                type: { ...el.tag.type }
              }
            }
            return formated
          } else {
            return el
          }
        })
        expense.transaction = {}
        expense.transaction.transactionTags = formatedTransactionTags
      } else {
        expense.transaction = {}
        expense.transaction.transactionTags = []
      }
      try {
        await this.$store.dispatch('TransactionsStore/createTransaction', expense)
        const files = []
        const types = []
        this.expensesReceipts.forEach((el) => {
          files.push(el.file)
          types.push(el.media.type)
        })
        await this.$store.dispatch(
          'TransactionsStore/submitTransactionReceipt',
          { id: this.newExpense, files: files, types: types }
        )
        this.$emit('expenseCreated', { force: true })
        this.$store.dispatch('TransactionsStore/resetExpenseReceipts')
        this._reset()
        this.closeModal()
      } catch (error) {
        console.log(error)
      } finally {
        this.isSubmitting = false
        if (this.$route.name !== 'my_history_reimbursements') {
          this.$router.push({ name: 'my_history_reimbursements' })
        }
      }
    },
    async editDiet (reviewStatus) {
      if (this.isSubmitting) return
      this.isSubmitting = true
      let transaction = {
        expense: {
          id: this.expenseId,
          ...this.generateDietModel()
        }

      }
      if (this.budget) {
        transaction.budget = { id: this.budget.id }
      }

      if (this.withoutTicket.withoutTicket) {
        transaction = { ...transaction, ...this.withoutTicket }
      }

      if (this.withoutTicket.withoutTicket) {
        transaction = { ...transaction, ...this.withoutTicket }
      }
      if (reviewStatus) {
        const { id } = this.reviewStatusTypes.find(el => el.code === reviewStatus)
        if (id) {
          transaction.reviewStatus = { id: id }
        }
      }
      if (this.transactionTags.length > 0) {
        const formatedTransactionTags = this.transactionTags.map(el => {
          if (typeof el.tag.id === 'string') {
            const formated = {
              tag: {
                name: el.tag.name,
                type: { ...el.tag.type }
              }
            }
            return formated
          } else {
            return el
          }
        })

        transaction.transactionTags = formatedTransactionTags
      } else {
        transaction.transactionTags = []
      }

      try {
        await this.$store.dispatch('TransactionsStore/editTransaction', {
          transactionInformation: { id: this.transaction.id, ...transaction },
          originalTransaction: this.transaction
        })
        this.closeModal()
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errrorMessage: 'expense_edit_diet_error' })
      } finally {
        this.isSubmitting = false
      }
    },
    _reset () {
      this.diet = {
        type: { id: 2 },
        amount: null,
        notes: '',
        date: null,
        diet: {}
      }
      this.dietSteps = [
        {
          date: null,
          placeInfo: {
            name: '',
            lat: '',
            lng: ''
          },
          stepOrder: 1
        },
        {
          date: null,
          placeInfo: {
            name: '',
            lat: '',
            lng: ''
          },
          stepOrder: 2
        }
      ]
      this.budget = null
      this.dietCategoryList = []
      this.$store.dispatch('TransactionsStore/resetCurrentTransaction')
    },
    _initialize () {
      const { expense } = this.transaction
      this.budget = this.transaction && this.transaction.budget ? this.transaction.budget : null
      this.originalBudgetId = this.budget
      this.paymentMethod = this.transaction.expense?.paymentMethod?.id ? { ...this.transaction.expense.paymentMethod } : this.paymentMethod
      this.originalPaymentMethod = { ...this.paymentMethod }
      expense.diet.dietCategoryConfigs.forEach(dietCategoryConfig => {
        const categoryToUpdate = this.dietCategoryList.find(el => {
          return el.dietCategory.id === dietCategoryConfig.dietCategory.id
        })

        if (categoryToUpdate) {
          categoryToUpdate.count = dietCategoryConfig.count
          categoryToUpdate.rate = dietCategoryConfig.rate
          categoryToUpdate.value = dietCategoryConfig.value
          categoryToUpdate.status = true
          if (this.dietCategoryList.length > 5) { this.selectedDietCategories.push(categoryToUpdate) }
        }
      })
      this.dietSteps = [...expense.diet.dietSteps.map(el => {
        return {
          id: el.id,
          date: el.date ? el.date : null,
          placeInfo: {
            name: el.placeInfo.name,
            lat: el.placeInfo.lat,
            lng: el.placeInfo.lng
          },
          stepOrder: el.stepOrder
        }
      })]
      if (this.dietSteps.length >= 2) {
        this.routeWaypoints = this.generateMapWaypoints()
        this.mapsId++
      }
      this.transactionReviewedFlag = this.transaction.reviewedAt !== null
      this.diet.notes = this.transaction.expense.notes
      this.originalNotes = this.diet.notes
      this.originalDietStepsData = cloneDeep(this.dietSteps)
      this.originalDietCategoryListData = cloneDeep(this.dietCategoryList)
      this.transactionTags = this.transaction.transactionTags
        ? this.transaction.transactionTags
        : []

      this.originalTransactionTags = [...this.transactionTags]
    }

  },
  async created () {
    this.$store.dispatch('TransactionsStore/clearCurrentTransaction')
    this.isInitializing = true
    const promises = []
    this._reset()
    if (this.transactionId) {
      await this.fetchTransaction()
    }
    promises.push(this.fetchPaymentMethods())
    promises.push(this.fetchDietCategories())
    promises.push(this.fetchCurrentTransactionUserBudgets())

    Promise.allSettled(promises).then(() => {
      this._initializeDietCategoryList()
      if (this.transactionId) {
        this._initialize()
        this.checkPaymentMethodInList()
      } else {
        if (this.budgets.length === 1) {
          this.budget = this.budgets[0]?.budget
        }
      }
      this.getBudgetTagTypes(INCLUDE_IN_TRANSACTION_TYPES.DIET)
      this.originalDietStepsData = cloneDeep(this.dietSteps)
      this.isInitializing = false
    })
  },
  destroyed () {
    this.$store.dispatch('TransactionsStore/clearCurrentTransaction')
    this.$store.dispatch('TransactionsStore/resetExpenseReceipts')
  },
  watch: {
    transactionId: async function (newV) {
      if (newV) {
        this.isInitializing = true
        this._reset()
        await this.fetchTransaction()
        await this.fetchPaymentMethods()
        await this.fetchDietCategories()
        await this.fetchCurrentTransactionUserBudgets()
        this._initializeDietCategoryList()
        this._initialize()
        await this.getBudgetTagTypes(INCLUDE_IN_TRANSACTION_TYPES.DIET)
        this.isInitializing = false
      }
    }
  }
}

</script>

<style scoped lang="scss" src="@/assets/styles/transactions/transactions-edit.scss"></style>

<style lang="scss" scoped>
.currency-symbol {
  top: 12px;
  color: var(--text-placeholder);
  font-weight: 400;
}
.currency-input {
  background-color: #fff;
  &:disabled {
    color: var(--text-placeholder);
  }
}

.add-destiny {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-link);
  margin-top: 8px;
  .res {
    display: none;
  }
  .non-res {
    display: block;
  }
}

.diet-location-container {
  display: flex;
  flex-direction: column;
  &--row {
    display: flex;
    flex-direction: row;
    margin: 5px 0px;
    width: 100%;
  }
}

.res {
  display: none;
}
.map-smaller {
  display: none;
}

@media screen and (max-width: 576px) {
  .map--smaller {
    display: block;
    max-height: 300px;
    height: 100%;
  }
  .grid-diet--map-column {
    display: none;
  }
  .diet-location-container--row {
    flex-direction: column;
  }
  .block--destination {
    margin-bottom: 25px;
  }
  .diet-step--block,
  .diet-step--block--date {
    width: 100% !important;
    max-width: 100% !important;
    margin: 5px 0px !important;
  }
  .Form-field--origin {
    max-width: 100% !important;
    width: 100% !important;
    margin: 0px !important;
  }
  .inter--step {
    max-width: 90% !important;
  }
  .last--step {
    max-width: 78% !important;
  }

  .add-destiny.res {
    display: block;
  }
  .add-destiny.non-res {
    display: none;
  }
  .Form-field--res {
    width: 100%;
    max-width: 80vw;
  }
}

@media (min-width: 576px) {
  .ModalBox {
    width: 80vw;
    @media screen and (min-width: 577px) and (max-width: 992px) {
      max-width: calc(100vw - 32px) !important;
      width: 100%;
    }
  }
  .Tit--modal {
    margin: auto;
  }
}
.Form-field--origin {
  max-width: 260px;
  width: 100%;
  margin: 2px;
  display: flex;
  align-items: center;
}
.Form-field--shorter {
  max-height: 40px;
  max-width: 50px;
  padding: 2px;
  min-height: fit-content;
  margin: 5px 0px;
}
.Form-field--short {
  padding: 2px;
  max-height: 40px;
}
.diet-step--block {
  width: 100%;
  max-width: 260px;
  max-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.diet-step--block--date {
  max-width: 220px;
  width: 100%;
  max-height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0px 5px;
}
.d-flex > .Form-field--fixed {
  margin: 2px;
}
.inter--step {
  max-width: 85%;
  width: 100%;
}
.last--step {
  max-width: fit-content;
}

.Form--field-error {
  border: 2px solid var(--semantic-negative-main);
}
.ModalBox {
  max-width: 992px;
  width: 100%;
}
.map-content {
  width: 462px !important;
  position: fixed !important;
  height: calc(95vh - 72px) !important;
  @media screen and (min-width: 577px) and (max-width: 992px) {
    width: 368px !important;
  }
}

.Fuell-Button {
  max-width: 465px;
  width: 100%;
}
.grid-diet--footer {
  grid-gap: 10px;
}
</style>
<style lang="scss">
.grid-diet {
  display: grid;
  grid-template-columns: 1fr 1fr !important;
  grid-gap: 24px !important;
  @media screen and (max-width: 576px) {
    grid-template-columns: 1fr !important;
  }

  &--first-column {
    grid-column: 2 / 3;
    @media screen and (max-width: 576px) {
      grid-column: 1/2;
      grid-gap: 0px;
    }
  }
  &--map-column {
    grid-column: 1 / 2;
    grid-row: 1/-1;
  }
}

.grid-diet--footer {
  grid-gap: 22px !important;
  @media screen and (max-width: 576px) {
    padding: 0px 1rem !important;
  }

  .funnel-actions-container {
    width: 100%;
    max-width: 100%;
    .Fuell-Button {
      max-width: 223px;
      .Fuell-Button--label {
        width: 100%;
        text-align: center;
      }
    }
    .Fuell-button--approve-dropdown-container {
      max-width: 32px !important;
      .Fuell-button-approve-dropdown {
        width: 230px;
        right: 0px;
        @media screen and (max-width: 576px) {
          width: 173px;
          right: -4px;
        }
      }
    }
  }
}
#funnel-actions > .Fuell-Button:nth-child(2) {
  margin-right: 0px;
}
</style>
<style>
#approve-content {
  max-width: 228px;
  width: 100%;
}
</style>
